import { ImageCollage } from "./ImageCollage";
import type { StepImageBinding } from "../../utils/ragChatUtils";

/**
 * Thin adapter: maps step image bindings onto the shared {@link ImageCollage}.
 * Prefer {@link ImageCollage} directly for non-step contexts.
 */
export function StepImageCollage({
  items,
  onOpen,
  tapToOpenLabel,
  morePhotosLabel,
  zoomLabel,
}: {
  items: StepImageBinding[];
  onOpen: (src: string) => void;
  tapToOpenLabel: string;
  morePhotosLabel: (count: number) => string;
  zoomLabel: string;
}) {
  const images = items
    .filter((b) => Boolean(b.img.path))
    .map((b) => ({ src: b.img.path }));

  return (
    <ImageCollage
      images={images}
      onOpen={onOpen}
      tapToOpenLabel={tapToOpenLabel}
      morePhotosLabel={morePhotosLabel}
      zoomLabel={zoomLabel}
      singleImageLayout="fixed"
      compactRoot
    />
  );
}
